const Service = require('gui/inputs/service');

module.exports = class IntegerService extends Service {
  constructor(opts = {}) {
    super(opts);
  }
};